<template>
  <div>
    <transition name="fade">
      <logo-component v-show="!isPlacePickerActive"/>
    </transition>
    <div class="gradient" :class="{'gradient--visible': fourthAddStep}"/>
    <menu-button v-if="addPlaceOpened" type="open" @click.native="$router.push({ name: 'map' })"/>
    <preloader-container/>

    <!--
      `map-view` has to be always mounted due to Google Map initialization delay
      To keep proper routing there is a view called `MapFaker`
    -->
    <map-view/>
    <place-picker-container/>
    <contest-menu-container/>

    <transition :name="transition">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import LogoComponent from '@/components/Logo'
import PreloaderContainer from '@/containers/PreloaderContainer'
import MapView from '@/views/Map'

import PlacePickerContainer from '@/containers/PlacePicker'
import ContestMenuContainer from '@/containers/ContestMenu'
import MenuButton from '@/containers/ContestMenu/MenuButton'

export default {
  components: {
    LogoComponent,
    MapView,
    PreloaderContainer,
    PlacePickerContainer,
    ContestMenuContainer,
    MenuButton
  },
  data () {
    return {
      transition: 'fade',
      hasPrivacyConsent: window.localStorage.getItem('privacyConsent') === 'true'
    }
  },
  computed: {
    ...mapState({
      isPlacePickerActive: state => state.picker.isActive
    }),
    addPlaceOpened () {
      return this.$route.path.startsWith('/dodaj/') && !this.$route.path.startsWith('/dodaj/wybierz')
    },
    fourthAddStep () {
      return this.$route.path.startsWith('/dodaj/krok-4')
    }
  },
  watch: {
    $route (to, from) {
      this.transition = from.name === 'home' || to.name === 'home'
        ? 'slide-vertically'
        : 'fade'
    }
  }
}
</script>

<style lang="scss">
  @import "../node_modules/normalize.css";
  @import "~@/assets/sass/globals";

  .gradient {
    z-index: z(logo);
    content: "";
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 111px;
    background: linear-gradient(to bottom, #b21313 58%, rgba(255, 0, 0, 0) 100%);
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s;
    &--visible {
      @media screen and (max-width: 832px) {
        visibility: visible;
        opacity: 1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue